/**
 * Modal "Fale conosco pelo WhatsApp" (rodape-site).
 *
 * Todo CTA de WhatsApp do site abre este modal — o número nunca está no HTML: o servidor só devolve
 * a URL (com a mensagem pré-preenchida e o [ref: …] da página) depois do envio. "Outro assunto" não
 * abre o WhatsApp: mostra o e-mail de contato.
 *
 * O contexto da página (tipo, slug e nome do palestrante/tema) vem do marcador
 * [data-whatsapp-contexto] dentro do #site-page, lido no clique (a navegação troca o #site-page sem
 * recarregar). Eventos do dataLayer documentados em TRACKING.md — nunca com e-mail ou telefone.
 */
($ => {

    const modal = () => document.querySelector(".modal-whatsapp-contact");
    let rastreio = {};

    /** Página atual + local do CTA, nos nomes de parâmetro do TRACKING.md */
    function contextoDoClique(cta) {
        const marcador = document.querySelector("#site-page [data-whatsapp-contexto]");
        const tipo = marcador?.dataset.pageType || "outro";
        const slug = marcador?.dataset.slug || "";
        return {
            page_path: window.location.pathname,
            page_type: tipo,
            speaker_slug: tipo === "perfil" ? slug : "",
            tema_slug: tipo === "tema" ? slug : "",
            cta_location: cta?.dataset.ctaLocation || "outro",
            _nome: marcador?.dataset.nome || "",
            _slug: slug,
        };
    }

    function pushEvento(event, extra = {}, callback = null) {
        window.dataLayer = window.dataLayer || [];
        const { _nome, _slug, ...parametros } = rastreio;
        const entrada = { event, ...parametros, ...extra };
        if (callback) {
            // Navegar só depois do GTM processar o evento (com limite, caso o GTM não carregue)
            let feito = false;
            const seguir = () => { if (!feito) { feito = true; callback(); } };
            entrada.eventCallback = seguir;
            entrada.eventTimeout = 1500;
            setTimeout(seguir, 1700);
        }
        window.dataLayer.push(entrada);
    }

    function prepararModal(dialog) {
        const form = dialog.querySelector("#form-whatsapp-contact");
        form.reset();
        form.querySelectorAll("input, select, textarea, button").forEach(campo => campo.disabled = false);
        dialog.querySelectorAll(".msg-success, .msg-error").forEach(el => el.remove());
        dialog.querySelector("[data-whatsapp-outro]").hidden = true;
        const botao = dialog.querySelector("button[form=form-whatsapp-contact]");
        botao.style.display = "";
        if (botao.dataset.textoWhatsapp) botao.textContent = botao.dataset.textoWhatsapp;
        form.elements.paginaTipo.value = rastreio.page_type;
        form.elements.paginaSlug.value = rastreio._slug;
        form.elements.paginaNome.value = rastreio._nome;
        form.elements.paginaOrigem.value = window.location.pathname + window.location.search;
    }

    $(document).on("click", ".whatsapp-floating-button, [data-whatsapp-contact-open]", function (event) {
        event.preventDefault();
        const dialog = modal();
        if (!dialog || dialog.open) {
            return;
        }
        rastreio = contextoDoClique(this);
        pushEvento("whatsapp_click_open");
        prepararModal(dialog);
        dialog.showModal();
    });

    // Com "Outro assunto" o envio não leva ao WhatsApp: o botão não promete isso
    $(document).on("change", "#whatsappContactTipo", function () {
        const botao = this.closest("dialog").querySelector("button[form=form-whatsapp-contact]");
        botao.dataset.textoWhatsapp ||= botao.textContent.trim();
        botao.textContent = this.value === "outro" ? "Enviar" : botao.dataset.textoWhatsapp;
    });

    $(document).on("form_ajax_submit", (event, responseResult, action) => {
        if (action !== "enviar_contato_whatsapp") return;

        const form = $("#form-whatsapp-contact");
        const message = formMessage.createFormMessage(responseResult);

        form.siblings(".msg-success, .msg-error").remove();
        form.before(message);

        if (responseResult.status !== "success") return;

        const tipoContato = form.find("[name=tipoContato]").val();
        pushEvento("whatsapp_modal_submit", { contact_type: tipoContato });
        trackWhatsappLead(responseResult.data?.conversion_event);
        form.find(":input").prop("disabled", true);

        if (responseResult.data?.email) {
            // Outro assunto: mostra o e-mail no lugar de abrir o WhatsApp
            message.remove();
            form.closest("dialog").find("[data-whatsapp-outro]").prop("hidden", false);
            // .site-btn define display: o atributo hidden não bastaria
            form.closest("dialog").find("button[form=form-whatsapp-contact]").hide();
            return;
        }
        if (!responseResult.data?.redirect_url) return;

        const url = responseResult.data.redirect_url;
        setTimeout(() => {
            pushEvento("whatsapp_redirect", { contact_type: tipoContato }, () => window.location.assign(url));
        }, 1200);
    });

    /**
     * O WhatsApp sai do site (`wa.me`), então o pageview da thank-you nunca acontece: sem este
     * evento o CTA mais usado do site não aparece como lead no GA4/Ads. Mesmo contrato do
     * orçamento e do contato — `generate_lead` + `form_id`, sem e-mail nem telefone.
     */
    function trackWhatsappLead(conversionEvent) {
        if (typeof window.siteTrackLeadConversion === "function") {
            window.siteTrackLeadConversion({
                event: conversionEvent || "generate_lead",
                form_id: "whatsapp",
                form_name: "Contato pelo WhatsApp",
                thankYouUrl: window.location.href,
            });
            return;
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: conversionEvent || "generate_lead",
            form_id: "whatsapp",
            form_name: "Contato pelo WhatsApp",
            page_location: window.location.href,
            page_path: window.location.pathname,
        });
        document.dispatchEvent(new CustomEvent("motiveacao:lead-converted", {
            detail: { form: "whatsapp" },
        }));
    }
})(jQuery);
